/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {ActionType, createAction} from 'typesafe-actions';
import {AccountEmailChangeStateDTO} from '../../generated/iam-client';

export const accountEmailChangeSceneActivated =
	createAction('ACCOUNT_EMAIL_CHANGE_SCENE_ACTIVATED')();

export const accountEmailChangeSceneDeactivated =
	createAction('ACCOUNT_EMAIL_CHANGE_SCENE_DEACTIVATED')();

export const accountEmailChangeSceneStateRetrieved =
	createAction('ACCOUNT_EMAIL_CHANGE_SCENE_STATE_RETRIEVED')<{ state: AccountEmailChangeStateDTO }>();

export const accountEmailChangeSceneRetrieveStateNotFound =
	createAction('ACCOUNT_EMAIL_CHANGE_SCENE_RETRIEVE_ACCOUNT_EMAIL_CHANGE_STATE_NOT_FOUND')();

export const accountEmailChangeSceneRetrieveStateUnexpectedError =
	createAction('ACCOUNT_EMAIL_CHANGE_SCENE_RETRIEVE_STATE_UNEXPECTED_ERROR')();

export const accountEmailChangeSceneStateChanged =
	createAction('ACCOUNT_EMAIL_CHANGE_SCENE_STATE_CHANGED')<{ state: AccountEmailChangeStateDTO }>();

// noinspection DuplicatedCode
export type ActionTypes =
	ActionType<typeof accountEmailChangeSceneActivated> |
	ActionType<typeof accountEmailChangeSceneDeactivated> |
	ActionType<typeof accountEmailChangeSceneStateRetrieved> |
	ActionType<typeof accountEmailChangeSceneRetrieveStateNotFound> |
	ActionType<typeof accountEmailChangeSceneRetrieveStateUnexpectedError> |
	ActionType<typeof accountEmailChangeSceneStateChanged>;
